import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogContentText } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import React from "react";
import { _post } from "../../../Api";
import { toast } from "react-toastify";

export default function SendEmailDialog(props) {
  const sendEmailDialog = props.sendEmailDialog;
  const setSendEmailDialog = props.setSendEmailDialog;
  const getSelectedAccount = props.getSelectedAccount;
  const merchantId = props.merchant.id;

  function closeDialog() {
    setSendEmailDialog(false);
  }

  function sendMail() {
    if (!!!cloudUser.password) {
      toast.error("Password was not filled in.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    _post("/nova/merchant/" + merchantId + "/cloudaccount/" + cloudUser.cloudUserId + "/welcomeemail", cloudUser)
      .then(() => {
        toast.success("Email was sent successfully.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        closeDialog();
      })
      .catch((e) => {
        toast.error("Password could not be changed or email could not be sent.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
      });
  }

  if (sendEmailDialog === false) {
    return <div />;
  }

  let cloudUser = {
    username: getSelectedAccount().username,
    cloudUserId: getSelectedAccount().cloudUserId,
    password: getSelectedAccount().password,
    sendEmail: getSelectedAccount().sendEmail,
  };

  return (
    <Dialog open={sendEmailDialog} onClose={closeDialog}>
      <DialogTitle>Send yourself an email confirming change of password</DialogTitle>
      <DialogContent>
        <DialogContentText>Please enter your new password:</DialogContentText>
        <Paper variant={"outlined"} style={{ margin: "1em" }}>
          <TextField
            autoFocus
            margin="dense"
            id="handheld password"
            label="Password"
            type="text"
            required
            onBlur={(event) => {
              cloudUser.password = event.target.value;
            }}
          />
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} color={"primary"}>
          Cancel
        </Button>
        <Button onClick={sendMail} color={"primary"}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
